const generateNaverAuthUrl = (): string => {
  const CLIENT_ID = process.env.NEXT_PUBLIC_NAVER_AUTH_CLIENT_ID;
  const CALLBACK_URL = process.env.NEXT_PUBLIC_NAVER_AUTH_CALLBACK_URL;
  const STATE = process.env.NEXT_PUBLIC_NAVER_AUTH_STATE;
  

  if (!CLIENT_ID || !CALLBACK_URL || !STATE) {
    throw new Error("Missing required environment variables for Naver Login.");
  }

  return `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${CLIENT_ID}&redirect_uri=${encodeURIComponent(
    CALLBACK_URL
  )}&state=${STATE}`;
};

function NaverLoginBtn() {
  const handleLoginClick = () => {
    try {
      const authUrl = generateNaverAuthUrl();
      //console.log("authUrl", authUrl);
      window.location.href = authUrl;
    } catch (error) {
      //console.error("Failed to generate Naver auth URL:", error);
    }
  };

  return (
    <div className="click" onClick={handleLoginClick}>
      <img
        src="/images/login/btn_login_naver.svg"
        alt="Naver Login"
        width="48"
      />
    </div>
  );
}

export { NaverLoginBtn };
